import { post } from '@va/http-client';

export const authenticateByInstance = (instance) => {
  const url = '/wix/token';
  const data = { type: 'encodedInstance', data: instance };

  return post(url, { instance: instance }, data);
};
